import { AppointmentInformation } from '../components';

export const config = {
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
  BookingReview: {
    icsEvent: {
      isServiceNameIncludedToAppointmentTypeName: true,
    },
  },
};
